<template>
  <button
    @click="setActiveIndex(index)"
    class="group-hover:text-typography font-bold ease-in-out my-3 paragraph break-words whitespace-nowrap"
  >
    {{ label }}
  </button>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

interface NavigationButton {
  label: string;
  index: number;
}
type Emits = {
  (e: "setActiveIndex", idx: number): void;
};
const emit = defineEmits<Emits>();

const props = defineProps<NavigationButton>();
const { label, index } = toRefs(props);

function setActiveIndex(idx: number) {
  emit("setActiveIndex", idx);
}
</script>
